import React from "react"
import ContainerPage from "../../components/ContainerPage/ContainerPage"
import History from "./History"


const HistoryPage = () => {
  return (
    <ContainerPage>
      <History historyPage={true}/>
    </ContainerPage>
  )
}

export default HistoryPage